export default "__VITE_ASSET__U5EUaBcK__"